<template>
  <div>
    <CCol md="6">
      <CForm @submit.prevent="saveUser">
        <CCard>
          <CCardHeader>
            {{ isUserCreate ? "Create" : "Edit" }} User
          </CCardHeader>
          <CCardBody>
            <CInput
              label="Email"
              placeholder="Enter email"
              type="email"
              horizontal
              autocomplete="email"
              :disabled="!isEdit"
              v-model="user.email"
              required
            />
            <CInput
              pattern="(?=.*[A-Z]).*[!@#\$%\^&\*\(\)_\+=\{\}\[\]:;<>,\.\?\~\/\-]+.*"
              label="Password"
              :placeholder="`Enter ${isUserCreate ? '' : 'new'} password`"
              type="password"
              horizontal
              v-if="isEdit || isUserCreate"
              :disabled="!isEdit"
              v-model="user.password"
              :required="isUserCreate"
              minLength="12"
              autocomplete="new-password"
            />
            <CInput
              label="First name"
              placeholder="Enter first name"
              horizontal
              autocomplete="name"
              :disabled="!isEdit"
              v-model="user.firstname"
              v-if="!isUserCreate"
            />
            <CInput
              label="Last name"
              placeholder="Enter last name"
              horizontal
              autocomplete="name"
              :disabled="!isEdit"
              v-model="user.lastname"
              v-if="!isUserCreate"
            />
            <div class="my-2 ml-3" v-if="!isUserCreate">
              <div class="mb-1">Active</div>
              <CInputRadioGroup
                v-if="isEdit"
                :options="YES_NO_OPTIONS"
                :checked.sync="user.is_active"
              />
              <div v-else>
                {{ user.is_active ? "Yes" : "No" }}
              </div>
            </div>
            <div class="ml-3" v-if="!isUserCreate">
              <div class="mb-1">Superuser</div>
              <CInputRadioGroup
                v-if="isEdit"
                :options="YES_NO_OPTIONS"
                :checked.sync="user.is_superuser"
              />
              <div v-else>
                {{ user.is_superuser ? "Yes" : "No" }}
              </div>
            </div>
          </CCardBody>
          <CCardFooter align="right">
            <div v-if="isEdit" class="d-flex gap-1">
              <CButton @click="resetForm" color="danger" size="sm">
                <i class="fa fa-ban" /> {{ $t("Reset") }}
              </CButton>
              <CButton type="submit" color="primary" size="sm">
                <i class="fa fa-save" /> {{ $t("Submit") }}
              </CButton>
            </div>
            <CButton @click="toggleEdit" color="primary" size="sm" v-else>
              <i class="fa fa-edit" /> {{ $t("Edit") }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CForm>
    </CCol>
  </div>
</template>

<script>
import { freeSet } from '@coreui/icons';
import { users } from '@/services/users';
import { YES_NO_OPTIONS } from '@/constants/options';

export default {
  name: 'user',
  freeSet,
  props: {},
  data() {
    return {
      YES_NO_OPTIONS,
      isEdit: true,
      isUserCreate: false,
      id: this.$route.params.id,
      user: {},
      userCopy: {},
    };
  },
  async mounted() {
    this.isUserCreate = this.id === "new";
    if (this.isUserCreate) {
      this.isEdit = true;
    } else {
      this.fetchUser();
      this.isEdit = this.$route.query.edit;
    }
  },
  methods: {
    resetForm() {
      this.user = { ...this.userCopy };
      this.toggleEdit();
    },
    toggleEdit() {
      this.isEdit = !this.isEdit;
    },
    async fetchUser() {
      this.user = await users.getUser(this.id);
      this.userCopy = { ...this.user };
    },
    async saveUser() {
      if (this.isUserCreate) {
        this.user = await users.createUser(this.user);
        this.$router.replace(`/admin/users/${this.user.id}`);
      } else {
        this.user = await users.editUser(this.id, this.user);
      }
      this.isUserCreate = false;
      this.isEdit = false;
    },
  },
};
</script>
